<template>
  <v-chip
    :color="presentation.color"
    :small="!xSmall"
    :x-small="xSmall"
    dark
    label
    class="run-status-chip"
    :class="`run-status-chip--${normalizedStatus.toLowerCase()}`"
    :title="title || presentation.label"
  >
    <v-icon v-if="showIcon" left x-small>{{ presentation.icon }}</v-icon>
    {{ presentation.label }}
  </v-chip>
</template>

<script>
import { normalizeRunStatus } from '@/store/modules/analysisQueue';
import { runStatusPresentation } from '@/utils/runLabels';

/**
 * Ledger status of a run as a coloured chip (QUEUED ... SUCCEEDED / FAILED / CANCELLED).
 */
export default {
  name: 'RunStatusChip',

  props: {
    status: {
      type: String,
      default: null,
    },
    xSmall: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: null,
    },
  },

  computed: {
    normalizedStatus() {
      return normalizeRunStatus(this.status) || 'UNKNOWN';
    },
    presentation() {
      return runStatusPresentation(this.status);
    },
  },
};
</script>
